import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendCmd } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      tagList: [{
        key: 4,
        value: '金镯'
      }, {
        key: 5,
        value: '理事'
      }, {
        key: 6,
        value: '飞兔'
      }, {
        key: 7,
        value: '飞马'
      }, {
        key: 11,
        value: '金包银'
      }],
      form: {
        sta_type: 4,
        month: ''
      },
      rules: {
        month: [{
          month: true,
          message: '请输入考核的月份',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show() {
      this.dialogVisible = true;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      var params = ['sta' + this.form.sta_type, '-month', this.form.month];

      if (this.form.sta_type == 11) {
        params = ['sta' + this.form.sta_type];
      }

      sendCmd(params).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('提交成功，请等待2分钟后刷新文件列表', '提示', {
                  confirmButtonText: '确定'
                });

                _this.dialogVisible = false;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};